"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGrid = void 0;
var _Grid = require("./Grid");
// TODO: in v9, move styled() from Grid.jsx to here
var StyledGrid = _Grid.Grid;
exports.StyledGrid = StyledGrid;